import { Box, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";

type CardShellProps = {
	title: string;
	leading?: ReactNode;
	children: ReactNode;
	footer?: ReactNode;
};

export function CardShell({
	title,
	leading,
	children,
	footer,
}: CardShellProps) {
	return (
		<Box className="card-stage">
			<Box className="card-device">
				<Stack gap={4} px="lg" pt="md" pb="sm">
					<img
						src="/logo.png"
						alt="Плай"
						width={40}
						height={40}
						style={{ display: "block", borderRadius: "50%", flexShrink: 0 }}
					/>
					<Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
						{leading}
						<Text fw={600} size="lg">
							{title}
						</Text>
					</Box>
				</Stack>
				<Box px="lg" pb="xl" style={{ flex: 1 }}>
					{children}
				</Box>
				{footer ? (
					<Box
						px="lg"
						py="md"
						style={{
							position: "sticky",
							bottom: 0,
							background: "var(--card-device-bg)",
							paddingBottom: "max(16px, env(safe-area-inset-bottom))",
						}}
					>
						{footer}
					</Box>
				) : null}
			</Box>
		</Box>
	);
}
